export const NAV_TRANSLATIONS: Record<string, string> = {
  'nav.dashboard': 'Dashboard',
  'nav.sales.catalog': 'Catálogo de ventas',
  'nav.collections.devices': 'Dispositivos de Cobros',
  'nav.collections.settings': 'Configuración de Cobros',
  'nav.collections.emergencyImport': 'Importación de Emergencia',
  'nav.collections.feedback': 'Sugerencias de Cobradores',
  'nav.collections.agendaReport': 'Agenda de Cobros',
  'nav.training': 'Capacitaciones',
  'nav.assets.it': 'Activos IT',
  'nav.assets.assignments': 'Asignaciones de activos',
  'nav.assets.config': 'Configuracion de activos',
  'nav.assets.categories': 'Categorias',
  'nav.assets.brands': 'Marcas',
  'nav.assets.models': 'Modelos',
  'nav.chat': 'WhatsApp',
  'nav.userManagement': 'Usuarios',
  'nav.employees': 'Empleados',
  'nav.collections': 'Cobros',
  'nav.reports.collections': 'Reportes de cobros',
  'nav.collections.receiptConfirmations': 'Confirmar Recibo',
  'nav.reports': 'Reportes',
  'nav.documents': 'Documentos',
  'nav.documents.templates': 'Plantillas',
  'nav.accounting': 'Contabilidad',
  'nav.accounting.reimbursements': 'Reembolsos',
  'nav.events': 'Eventos',
  'nav.events.memorialServices': 'Servicios memoriales',
  'nav.events.obituaries': 'Obituarios',
  'nav.events.tributes': 'Homenajes',
  'nav.events.leaderboard': 'Ranking de homenajes',
  'nav.events.tributesLeaderboard': 'Ranking de homenajes',
  'nav.events.photoSlideshow': 'Presentación de fotos',
  'nav.memorialPlaques': 'Placas Conmemorativas',
  'nav.logistics': 'Logística',
  'nav.logistics.tasks': 'Tareas',
  'nav.logistics.operations': 'Operaciones',
  'nav.logistics.taskDocuments': 'Documentos de tarea',
  'nav.logistics.digitalDisplays':        'Pantallas Digitales',
  'nav.logistics.digitalDisplays.manage': 'Gestión de Pantallas',
  'nav.logistics.digitalDisplays.mine':   'Mis Pantallas',
  'nav.admin.users': 'Usuarios',
  'nav.settings': 'Configuración',
};
